import i18next from 'i18next';

import { apiClient, ApiClientResponse, PaginatedResponse } from '../services/api-client';
import { FormState } from '../../features/form/ducks';
import { Transaction } from '../models/Transaction';

export default {
  create: (owner: string, form: FormState): Promise<ApiClientResponse<Transaction>> =>
    apiClient.post(`/transactions`, {
      type: 'questionnaire',
      time: new Date().toISOString(),
      owner,
      entries: [{ meta: form }],
    }),
  edit: (id: string, form: Partial<FormState>): Promise<ApiClientResponse<Transaction>> =>
    apiClient.patch(`/transactions/${id}`, {
      entries: [{ meta: form }],
    }),
  remove: (id: string): Promise<ApiClientResponse<void>> =>
    apiClient.patch(`/transactions/${id}`, {
      status: 'deleted',
    }),
  find: (query?: Record<string, unknown>): Promise<ApiClientResponse<PaginatedResponse<Transaction>>> =>
    apiClient.get(`/transactions`, {
      params: {
        $limit: -1,
        $sort: { updatedAt: -1 },
        status: 'new',
        ...query,
      },
    }),
  findOne: (id: string): Promise<ApiClientResponse<Transaction>> => apiClient.get(`/transactions/${id}`),
  forwardDocuments: (
    id: string,
    documents: Array<{ blob: Blob; filename: string }>,
  ): Promise<ApiClientResponse<void>> => {
    const formData = new FormData();
    for (const document of documents) {
      formData.append('signedDocuments', document.blob, document.filename);
    }

    return apiClient.post(`/transactions/${id}/documents`, formData, {
      params: { lang: i18next.language },
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};
